export default __webpack_public_path__ + "static/maxkalis-97aae48af5993db8bd5d1e249a926d85.jpg";